<script>
    import { page } from '$app/stores';
    import Error404 from '$components/error-pages/Error404.svelte';
    import Error500 from '$components/error-pages/Error500.svelte';
    import Header from '$components/Header.svelte';
</script>

<div>
    <div class='container mx-auto sm:w-full max-w-5xl h-full'>
        <Header />
    </div>

    <div class='container mx-auto sm:w-full max-w-5xl px-4 h-full mt-3 mb-10'>
        <div class='flex flex-col max-h-full'>
            {#if $page.status === 404}
                <Error404 />
            {:else}
                <Error500 />
            {/if}
        </div>
    </div>
</div>